import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

interface QuestionHelpBarProps {
  questionLength: number;
}
const useStyles = makeStyles({
  container: {
    display: 'flex'
  },
  block: {
    margin: '2px',
    width: '58px',
    height: '23px',
    backgroundColor: '#DDDDDD'
  },
  red: {
    backgroundColor: '#C92A2A'
  },
  yellow: {
    backgroundColor: '#ED8031'
  },
  green: {
    backgroundColor: '#16A32C'
  }
});
const QuestionHelpBar = (props: QuestionHelpBarProps) => {
  const { questionLength } = props;
  const classes = useStyles();
  return (
    <div>
      <span>Have at-least 3 questions per passage</span>
      <div className={classes.container}>
        <div
          className={`${classes.block} 
        ${questionLength === 1 && classes.red}
        ${questionLength === 2 && classes.yellow}
        ${questionLength >= 3 && classes.green}
        `}
        ></div>
        <div
          className={`${classes.block} 
        ${questionLength === 2 && classes.yellow}
        ${questionLength >= 3 && classes.green}
        `}
        ></div>
        <div
          className={`${classes.block} 
        ${questionLength >= 3 && classes.green}
        `}
        ></div>
      </div>
    </div>
  );
};

export default QuestionHelpBar;
